/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction
} from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ErrorView } from '../model';
// @ts-ignore
import { InvitationCreateView } from '../model';
// @ts-ignore
import { InvitationListView } from '../model';
// @ts-ignore
import { InvitationReadView } from '../model';
/**
 * InvitationApi - axios parameter creator
 * @export
 */
export const InvitationApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create an invitation
     * @param {InvitationCreateView} [invitationCreateView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invitationResourceCreate: async (
      invitationCreateView?: InvitationCreateView,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/invitations`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication default required
      await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(invitationCreateView, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Delete an invitation
     * @param {number} id Invitation ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invitationResourceDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('invitationResourceDelete', 'id', id);
      const localVarPath = `/v1/invitations/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication default required
      await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary List invitations
     * @param {number} [limit] Maximum amount of items per page
     * @param {number} [offset] Page offset
     * @param {number} [organisationId] Filter by organisation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invitationResourceList: async (
      limit?: number,
      offset?: number,
      organisationId?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/invitations`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication default required
      await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (organisationId !== undefined) {
        localVarQueryParameter['organisationId'] = organisationId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @summary Read an invitation
     * @param {number} id Invitation ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invitationResourceRead: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('invitationResourceRead', 'id', id);
      const localVarPath = `/v1/invitations/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication default required
      await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};

/**
 * InvitationApi - functional programming interface
 * @export
 */
export const InvitationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = InvitationApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create an invitation
     * @param {InvitationCreateView} [invitationCreateView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async invitationResourceCreate(
      invitationCreateView?: InvitationCreateView,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvitationReadView>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.invitationResourceCreate(invitationCreateView, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Delete an invitation
     * @param {number} id Invitation ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async invitationResourceDelete(
      id: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.invitationResourceDelete(id, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary List invitations
     * @param {number} [limit] Maximum amount of items per page
     * @param {number} [offset] Page offset
     * @param {number} [organisationId] Filter by organisation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async invitationResourceList(
      limit?: number,
      offset?: number,
      organisationId?: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvitationListView>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.invitationResourceList(
        limit,
        offset,
        organisationId,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Read an invitation
     * @param {number} id Invitation ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async invitationResourceRead(
      id: number,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvitationReadView>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.invitationResourceRead(id, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    }
  };
};

/**
 * InvitationApi - factory interface
 * @export
 */
export const InvitationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = InvitationApiFp(configuration);
  return {
    /**
     *
     * @summary Create an invitation
     * @param {InvitationCreateView} [invitationCreateView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invitationResourceCreate(
      invitationCreateView?: InvitationCreateView,
      options?: any
    ): AxiosPromise<InvitationReadView> {
      return localVarFp
        .invitationResourceCreate(invitationCreateView, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete an invitation
     * @param {number} id Invitation ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invitationResourceDelete(id: number, options?: any): AxiosPromise<void> {
      return localVarFp.invitationResourceDelete(id, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List invitations
     * @param {number} [limit] Maximum amount of items per page
     * @param {number} [offset] Page offset
     * @param {number} [organisationId] Filter by organisation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invitationResourceList(
      limit?: number,
      offset?: number,
      organisationId?: number,
      options?: any
    ): AxiosPromise<InvitationListView> {
      return localVarFp
        .invitationResourceList(limit, offset, organisationId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Read an invitation
     * @param {number} id Invitation ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invitationResourceRead(id: number, options?: any): AxiosPromise<InvitationReadView> {
      return localVarFp.invitationResourceRead(id, options).then((request) => request(axios, basePath));
    }
  };
};

/**
 * Request parameters for invitationResourceCreate operation in InvitationApi.
 * @export
 * @interface InvitationApiInvitationResourceCreateRequest
 */
export interface InvitationApiInvitationResourceCreateRequest {
  /**
   *
   * @type {InvitationCreateView}
   * @memberof InvitationApiInvitationResourceCreate
   */
  readonly invitationCreateView?: InvitationCreateView;
}

/**
 * Request parameters for invitationResourceDelete operation in InvitationApi.
 * @export
 * @interface InvitationApiInvitationResourceDeleteRequest
 */
export interface InvitationApiInvitationResourceDeleteRequest {
  /**
   * Invitation ID
   * @type {number}
   * @memberof InvitationApiInvitationResourceDelete
   */
  readonly id: number;
}

/**
 * Request parameters for invitationResourceList operation in InvitationApi.
 * @export
 * @interface InvitationApiInvitationResourceListRequest
 */
export interface InvitationApiInvitationResourceListRequest {
  /**
   * Maximum amount of items per page
   * @type {number}
   * @memberof InvitationApiInvitationResourceList
   */
  readonly limit?: number;

  /**
   * Page offset
   * @type {number}
   * @memberof InvitationApiInvitationResourceList
   */
  readonly offset?: number;

  /**
   * Filter by organisation
   * @type {number}
   * @memberof InvitationApiInvitationResourceList
   */
  readonly organisationId?: number;
}

/**
 * Request parameters for invitationResourceRead operation in InvitationApi.
 * @export
 * @interface InvitationApiInvitationResourceReadRequest
 */
export interface InvitationApiInvitationResourceReadRequest {
  /**
   * Invitation ID
   * @type {number}
   * @memberof InvitationApiInvitationResourceRead
   */
  readonly id: number;
}

/**
 * InvitationApi - object-oriented interface
 * @export
 * @class InvitationApi
 * @extends {BaseAPI}
 */
export class InvitationApi extends BaseAPI {
  /**
   *
   * @summary Create an invitation
   * @param {InvitationApiInvitationResourceCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvitationApi
   */
  public invitationResourceCreate(
    requestParameters: InvitationApiInvitationResourceCreateRequest = {},
    options?: AxiosRequestConfig
  ) {
    return InvitationApiFp(this.configuration)
      .invitationResourceCreate(requestParameters.invitationCreateView, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete an invitation
   * @param {InvitationApiInvitationResourceDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvitationApi
   */
  public invitationResourceDelete(
    requestParameters: InvitationApiInvitationResourceDeleteRequest,
    options?: AxiosRequestConfig
  ) {
    return InvitationApiFp(this.configuration)
      .invitationResourceDelete(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List invitations
   * @param {InvitationApiInvitationResourceListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvitationApi
   */
  public invitationResourceList(
    requestParameters: InvitationApiInvitationResourceListRequest = {},
    options?: AxiosRequestConfig
  ) {
    return InvitationApiFp(this.configuration)
      .invitationResourceList(
        requestParameters.limit,
        requestParameters.offset,
        requestParameters.organisationId,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Read an invitation
   * @param {InvitationApiInvitationResourceReadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvitationApi
   */
  public invitationResourceRead(
    requestParameters: InvitationApiInvitationResourceReadRequest,
    options?: AxiosRequestConfig
  ) {
    return InvitationApiFp(this.configuration)
      .invitationResourceRead(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
